<button type="button" class="center-filter-toggle" [class.center-filter-toggle--active]="badge() > 0" (click)="togglePanel()">
  <span>{{ text().label }}</span>
  @if (badge() > 0) {
    <span class="center-filter-badge">{{ badge() }}</span>
  }
  <i class="fas fa-chevron-down center-filter-caret" aria-hidden="true"></i>
</button>

@if (panelOpen()) {
  <div class="center-filter-panel">
    @for (row of rows(); track row.property) {
      <div class="center-filter-row">
        <span class="center-filter-name">{{ row.name }}</span>
        <e-segmented-toggle
          class="center-filter-states"
          [testId]="'center-filter-' + row.property"
          [options]="toggleOptions()"
          [value]="stateValue(row.property)"
          (valueChange)="onStateChange(row.property, $event)"
        ></e-segmented-toggle>
      </div>
    }
    <div class="center-filter-footer">
      <button type="button" class="center-filter-apply" (click)="togglePanel()">{{ text().apply }}</button>
      <button type="button" class="center-filter-clear" (click)="clearDraft()">{{ text().clear }}</button>
    </div>
  </div>
}
